import * as React from "react";

import { ITemplatesApiClient } from "../../../Engine/Api/TemplateApiClient/ITemplatesApiClient";
import { reject } from "../../../../../Common/TypingUtils";

const TemplatesApiClientContext = React.createContext<ITemplatesApiClient | undefined>(undefined);

export function useTemplatesApi(): ITemplatesApiClient {
    return React.useContext(TemplatesApiClientContext) ?? reject("TemplatesApiClient is not provided");
}

export interface TemplatesApiProviderProps {
    templatesApi: ITemplatesApiClient;
    children: React.ReactNode;
}

export function TemplatesApiProvider(props: TemplatesApiProviderProps): React.ReactElement {
    return (
        <TemplatesApiClientContext.Provider value={props.templatesApi}>
            {props.children}
        </TemplatesApiClientContext.Provider>
    );
}
